<template>
  <div class="container">
    <CRow alignHorizontal="end" alignVertical="center">
      <div class="containerIconClose" @click="close()">
        <font-awesome-icon icon="times" class="IconClose" />
      </div>
    </CRow>
    <CCard class="customCard">
      <CCardHeader class="customCardHeaderActive">
        <CRow
          alignHorizontal="between"
          alignVertical="center"
          class="mr-2 ml-2"
        >
          <h3 :class="checkLangClass() + ' ' + 'm-2'">
            {{ $helpers.translate(chapterName, lang) }} :
            {{ $helpers.translate(chapterDesc, lang) }}
          </h3>
        </CRow>
      </CCardHeader>
      <CCardBody>
        <CRow class="m-1" align-horizontal="center" align-vertical="center">
          <CCol xl="6" lg="6" md="12" sm="12">
            <CRow class alignHorizontal="center" alignVertical="center">
              <div v-if="checkWidth > 500">
                <h1>{{ question }}</h1>
              </div>
              <div v-if="checkWidth <= 500">
                <h1 style="font-size: 25px; font-weight: 400">
                  {{ question }}
                </h1>
              </div>
            </CRow>
            <CRow class alignHorizontal="center" alignVertical="center">
              <!-- {{initialAnswer}} -->
              <template v-for="index of initialAnswer">
                <div
                  v-if="checkWidth > 500"
                  :key="index"
                  class="answer"
                  :class="getMatrixClass(index)"
                >
                  <div class="fontChinese">{{ index }}</div>
                </div>
                <div
                  v-if="checkWidth <= 500"
                  :key="index"
                  class="answer"
                  :class="getMatrixClass(index)"
                >
                  <div
                    class="fontChinese"
                    style="font-size: 25px; font-weight: 400"
                  >
                    {{ index }}
                  </div>
                </div>
              </template>
            </CRow>
          </CCol>
          <CCol xl="6" lg="6" md="12" sm="12">
            <CRow
              class="img-container p-2"
              alignHorizontal="center"
              alignVertical="center"
            >
              <template v-for="item of answer">
                <CCol :key="item" xl="6" lg="6" md="6" sm="6" class="p-1">
                  <div
                    class="matrix"
                    :id="item.choice.choices.item.comment"
                    @click="
                      select(
                        item.choice.choices.item.comment,
                        item.choice.choices.item.data
                      )
                    "
                  >
                    <div class="checkDisplay">
                      <!-- <div class="containerSmallAudio">
                        <font-awesome-icon class="SmallAudio" icon="volume-up" ></font-awesome-icon>
                      </div>-->
                    </div>
                    <h2
                      v-if="checkWidth > 500"
                      class="info-desc m-0 pt-4 pb-4 fontChinese"
                    >
                      {{ item.choice.choices.item.data }}
                    </h2>
                    <p
                      v-if="checkWidth <= 500"
                      class="info-desc m-0 pt-4 pb-4"
                      style="font-size: 20px"
                    >
                      {{ item.choice.choices.item.data }}
                    </p>
                  </div>
                </CCol>
              </template>
            </CRow>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import '../../../../assets/scss/_chineseStyle.scss';
import '../../../../assets/scss/_chineseIcon.scss';

export default {
  components: {},
  name: 'CardFillText',
  props: {
    setNext: Function,
    initialAnswer: Array,
    answer: Array,
    chapterName: Array,
    chapterDesc: Array,
    closePath: String,
    question: String,
    correctANS: String,
    isChangeTemplate: Boolean,
  },
  data() {
    return {
      data: {},
      answerCount: 0,
      lang: this.$store.getters['language/getLanguage'],
      checkWidth: window.innerWidth,
      answerLength: 0,
    };
  },

  computed: {
    ...mapGetters({
      storeLanguage: 'language/getLanguage',
      // getIsChangeTemplate: 'template/getIsChangeTemplate',
    }),
  },

  watch: {
    initialAnswer: function (val) {
      this.answerLength = val.length;
    },
    // answer: function () {},
    // getIsChangeTemplate: function (val) {
    //   this.answerCount = 0;
    // },
    answerCount(value) {
      if (this.initialAnswer.length == value) {
        this.$emit('setNext', true, this.initialAnswer);
        // this.answerCount = 0; //reset answerCount
      } else {
        this.$emit('setNext', false);
      }
    },
    storeLanguage: function (val) {
      this.lang = val;
    },
    isChangeTemplate(val) {
      if (val) {
        // console.log('ansCount set to 0');
        this.answerCount = 0;
      }
    },
  },

  mounted() {},

  created() {},

  beforeDestroy() {},
  methods: {
    checkLangClass() {
      if (this.lang == 'CN') {
        return 'fontChinese';
      } else if (this.lang == 'PIN IN') {
        return 'fontPinin';
      } else {
        return '';
      }
    },
    getMatrixClass(value) {
      if (value === undefined) return 'answer-blank';
      else return 'answer-answer';
    },
    close() {
      if (this.closePath === 'PreTest') {
        alert('You cannot exit while doing pretests.');
      } else {
        let str = this.closePath.split('-');
        this.$router.push(`/v4/${str[0]}/${str[1]}`);
      }
    },
    select(id, value) {
      let selectedItem = document.getElementById(id);
      let selectedItemChild = selectedItem.children[0];
      if (selectedItem.className == 'matrix') {
        this.addTheAnswer(value, selectedItem, selectedItemChild);
      } else {
        this.removeTheAnswer(value, selectedItem, selectedItemChild);
      }
    },
    addTheAnswer(value, selectedItem, selectedItemChild) {
      // console.log('add answer', value);

      if (this.answerCount >= this.initialAnswer.length) {
        // console.log('reset triggerd');

        this.clearTheAnswer();
        return;
      }
      this.initialAnswer.splice(this.answerCount, 1, value);
      this.answerCount += 1;
      this.activeTheMatrix(selectedItem, selectedItemChild);
    },
    removeTheAnswer(value, selectedItem, selectedItemChild) {
      // console.log('remove answer', value);

      this.unActiveTheMatrix(selectedItem, selectedItemChild);
      this.answerCount = this.answerCount - 1;
      for (let item in this.initialAnswer)
        if (this.initialAnswer[item] === value) {
          this.initialAnswer.splice(item, 1);
          this.initialAnswer.push(undefined);
        }
    },
    activeTheMatrix(selectedItem, selectedItemChild) {
      selectedItem.classList.add('matrix-active');
      selectedItemChild.style.display = 'block';
    },
    unActiveTheMatrix(selectedItem, selectedItemChild) {
      selectedItem.classList.remove('matrix-active');
      selectedItemChild.style.display = 'none';
    },
    clearTheAnswer() {
      this.answerCount = 0;
      let allSelected = document.getElementsByClassName('matrix');
      for (let item in this.initialAnswer) {
        this.initialAnswer.splice(item, 1, undefined);
      }
      for (let i = 0; i < allSelected.length; i++) {
        let eachItem = allSelected[i];

        if (!eachItem) continue;
        let eachItemChild = eachItem.children[0];

        if (eachItemChild) {
          this.unActiveTheMatrix(eachItem, eachItemChild);
        }
      }
    },
    checkLanguage(val) {
      if (val) {
        for (let i = 0; i <= val.length; i++) {
          if (val[i].key == this.lang) {
            return val[i].value;
          }
        }
      } else {
        console.log('check language', val);
      }
    },
  },
};
</script>

<style scoped lang="scss">
div.answer {
  margin: 2.5%;
  &-answer {
    div {
      display: flex;
      flex-direction: column;
      text-align: center;
      align-content: center;
      font-size: 50px;
      font-weight: bold;
      color: red;
    }
    div::after {
      content: '';
      display: block;
      position: relative;
      width: inherit;
      height: 5px;
      border-radius: 5px;
      background-color: #457ae6;
    }
  }
  &-blank {
    display: flex;
    justify-content: center;
    width: 50px;
    height: 50px;
    div {
      display: flex;
      flex-direction: column;
      text-align: center;
      align-content: center;
      width: 50px;
      font-size: 50px;
      font-weight: bold;
      color: red;
    }
    div::after {
      content: '';
      display: block;
      position: relative;
      top: 45px;
      width: 50px;
      height: 5px;
      border-radius: 5px;
      background-color: #457ae6;
    }
  }
}

.img-container {
  background-color: #f2f2f2 !important;
  width: auto;
  height: 100%;
  font-size: 80px;
  border-radius: 20px;
}

.matrix {
  width: 100%;
  height: 100%;
  justify-content: center;
  border-radius: 15px;
  margin-bottom: 0rem !important;
  background-color: white;
  outline: 0 !important;
  border: 5px solid white;
}

.matrix:hover {
  background-color: lightgray;
  box-shadow: 2px 2px 8px lightgray;
  cursor: pointer;
  border: 5px solid lightgray;
}

.matrix-active {
  width: 100%;
  height: 100%;
  justify-content: center;
  border-radius: 15px;
  margin-bottom: 0rem !important;
  background-color: #84d19b;
  border: 5px solid #457ae6;
  outline: 0 !important;
}

.matrix-active:hover {
  background-color: #84d19b;
  border: 5px solid #457ae6;
  cursor: pointer;
}

.info-desc {
  text-align: center;
  font-size: 40px;
}

.checkDisplay {
  display: none;
}
.SmallAudio {
  width: 15px;
  height: 15px;
}

@media screen and (min-width: 300px) and (max-width: 600px) {
  .img-container {
    margin-top: 15px;
  }
}
</style>
